import { render, staticRenderFns } from "./PlgBankServicesApi.vue?vue&type=template&id=51e21e78&"
import script from "./PlgBankServicesApi.vue?vue&type=script&lang=js&"
export * from "./PlgBankServicesApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports